/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import DownloadItemsModal from 'src/new_arch/modules/projectView/modals/DownloadItemsModal/DownloadItemsModal';
import { connectComponent } from '../../../lib/connectComponent';

import Nav from '../Nav/Nav';
import AuthenticationLinksContainer
	from '../../../containers/AuthenticationLinksContainer/AuthenticationLinksContainer';
import NavigationLogo from '../NavigationLogo/NavigationLogo';
import FileDownload from '../../../assets/img/icons/file-download.svg';
import SharedNavigationBreadcrumbsContainer from '../../../containers/SharedNavigationBreadcrumbsContainer/SharedNavigationBreadcrumbsContainer';

import './SharedViewNav.scss';
import Tooltip from '../../UI/Tooltip/Tooltip';
import useSharedViewNavPresenter from '../../../presenters/SharedViewNavPresenter/useSharedViewNavPresenter';
import Asset from '../../../entities/asset';
import { getSharedProjectAsset, getSharedEntity } from '../../../selectors/sharedProjects';
import SharedProject from '../../../entities/sharedProject';
import SharedFolder from '../../../entities/sharedFolder';
import ShareRef from '../../../structures/shareRef';

export const SharedViewNav = ( {
	shareRef, assetID, asset, sharedEntity
} ) => {
	const sharedEntityPath = shareRef.appPath;
	const shareEntityCustomBranding = sharedEntity?.customBranding;

	const presenter = useSharedViewNavPresenter( {
		assets: [ asset ]
	} );

	return (
		<Nav className="SharedViewNav">
			<div className="NavigationContainer">
				{!!sharedEntity && (
					<NavigationLogo
						linkURL={sharedEntityPath}
						isClickeable={false}
						customLogo={shareEntityCustomBranding?.logo}
					/>
				)}
				<SharedNavigationBreadcrumbsContainer
					shareRef={shareRef}
					assetID={assetID}
				/>
			</div>
			{ !!assetID && sharedEntity?.allowsDownloads && (
				<Tooltip
					className="file-download"
					title="Download"
					position="bottom"
				>
					<button onClick={presenter.downloadAllAssetsWasClicked}>
						<img
							data-testid="file-download"
							alt="file download"
							src={FileDownload}
						/>
					</button>
				</Tooltip>
			)}
			<AuthenticationLinksContainer shareRef={shareRef} />
			{presenter.isShowingDownloadPopup && (
				<DownloadItemsModal
					assets={presenter.assets}
					folders={[]}
					shareRef={shareRef}
					onClose={presenter.downloadAllAssetsPopupWasClosed}
				/>
			)}
		</Nav>
	);
};

SharedViewNav.propTypes = {
	shareRef: PropTypes.instanceOf( ShareRef ).isRequired,
	assetID: PropTypes.number,
	asset: PropTypes.instanceOf( Asset ),
	sharedEntity: PropTypes.oneOfType( [
		PropTypes.instanceOf( SharedProject ),
		PropTypes.instanceOf( SharedFolder )
	] )
};

SharedViewNav.defaultProps = {
	assetID: undefined,
	asset: undefined,
	sharedEntity: undefined
};

export default connectComponent( ( state, props ) => ( {
	asset: getSharedProjectAsset( state, props ),
	sharedEntity: getSharedEntity( state, props )
} ) )( SharedViewNav );
